export enum CustomMaskInputs {
  MASK = 'mask',
  TEXT = 'text',
  FOCUS = 'focus',
  CONVERT = 'convert',
  ALIGN_RIGHT = 'alignRight'
}
